import JSX, {h, Component, AnyComponent, ComponentChildren} from 'preact'
import TextButton from '../ui-components/TextButton'
import {isFunction} from "../../libs/typeGuards";
import GlobalClick from '../interactive/documentClick'

interface Props {
  triggerClass?: string,
  class?: string,
  triggerElement?: AnyComponent<{onClick: (e: Event) => void, disabled?: boolean}> | string,
  trigger?: ComponentChildren,
  children: JSX.Element,
  closeOnDropdownClick?: boolean,
  disabled?: boolean
}

interface State {
  isOpen: boolean,
}

export default class extends Component<Props, State> {
  render (props: Props) {
    const Trigger = props.triggerElement || TextButton
    return <div className={props.triggerClass}>
      <Trigger
        disabled={props.disabled}
        onClick={() => {
          if (props.disabled) {
            return
          }
          this.setState({ isOpen: !this.state.isOpen })
        }}>
        {props.trigger}
      </Trigger>
      {this.state.isOpen
        ? (
          <GlobalClick onGlobalClick={() => this.setState({ isOpen: false })}>
            <div className={props.class} onClick={() => this.setState({ isOpen: false })}>
              {isFunction(props.children[0]) && props.children[0]({
                close: () => this.setState({ isOpen: false })
              })}
              {props.children}
            </div>
          </GlobalClick>
        )
        : null}
    </div>
  }
}
